module.exports = __webpack_public_path__ + "media/fr_fr_s1_Amelie.a0298942.oga";